import React, { useState, useEffect } from "react";
import { Grid, Divider,CircularProgress } from "@mui/material";
import SideBar from "./index";

import { PostMethod } from "../../Helper/api"
const FAQs = () => {

  const [options, setOptions] = useState([]);
  const [Loader, setLoader] = useState(false);
  const filteredOptions = options
  useEffect(() => {
    GetFAQSList()
  }, []);
  const GetFAQSList =async()=>{
    try{
      let url ="faq/listfaq"
      let method ="POST"
      let params={
        "type":"faq"
      }
      setLoader(true)
      const response =await PostMethod({url,method,params})
      if(response.status){
        setLoader(false)
        setOptions(response.result)
      }else{
        setLoader(false)
        setOptions([])
      }
    }catch(Error){
      setLoader(false)
      console.log("err in GetFAQSList",Error)
    }
  }
  return (
    <Grid item container>
      <Grid item container justifyContent={"space-between"} className="mt-3">
        <Grid item container lg={3} md={3} sm={12} className="bg-white p-3 borderRadius10" alignSelf={"baseline"} flexDirection={"column"} alignItems={"flex-start"}>
          <SideBar />
        </Grid>
        <Grid item container lg={8.8} md={8.8} sm={12} className="bg-white p-3 borderRadius10" alignSelf={"baseline"}>
          <h4 className="Text-Prime-Black poppinsMedium text-left pt-2">Frequently Asked Questions</h4>
          <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
          {localStorage.getItem("@userType") == "superadmin" || localStorage.getItem("@userType") == "recruitadmin" ?
            <></>
            :
            <Grid
              item
              container
              lg={12}
              md={12}
              sm={12}
              xs={12}
              justifyContent={"space-between"}
              alignItems={"flex-start"}
              className="mt-4"
            >
              {filteredOptions.length > 0 ? (
                filteredOptions.map((val, index) => (<>
                  <Grid item container lg={12} key={index} justifyContent={"space-between"} alignItems={"flex-start"} className="mt-3 mb-3">
                    <Grid item container lg={12} flexDirection={"column"}>
                      <h5 className="poppinsMedium text-black text-left">{index + 1}. {val?.faq_title}</h5>
                      <p className="poppinsRegular text-black text-left pt-2">{val?.faq_content}</p>
                    </Grid>
                  </Grid>
                  <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                </>))
              ) : (
                <Grid item container lg={12} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                  {Loader &&<CircularProgress size="1rem" style={{ color: "#000" }} />}
                  <h5 className="text-black poppinsMedium mt-3 mb-3">No FAQs Available</h5>
                </Grid>
              )}
            </Grid>
          }
        </Grid>
      </Grid>
    </Grid>
  );
};
export default FAQs;